module.exports = __webpack_public_path__ + "img/46.60ac8a12.jpg";